/**
 * Wait for elements to exist in DOM before adding tour step listeners
 */
export function waitForElement(selector: string, timeout = 6000): Promise<HTMLElement | null> {
  const existing = document.querySelector<HTMLElement>(selector);

  if (existing) return Promise.resolve(existing);

  return new Promise((resolve) => {
    const observer = new MutationObserver(() => {
      const el = document.querySelector<HTMLElement>(selector);

      if (el) {
        observer.disconnect();
        clearTimeout(timer);
        resolve(el);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    const timer = setTimeout(() => {
      observer.disconnect();
      resolve(null);
    }, timeout);
  });
}
